import { AuditoriaBeanM } from './auditoria_bean';
import { ServiceCredencialesM } from './service-credenciales-bean';


export class DetFirmanteE {
  c_firmante:Number;
  c_constancia:Number;
  n_secuencia:Number;
  c_usuario:Number;
  c_oficina:Number;
  auditoriaBeanM:AuditoriaBeanM;
  serviceCredencialesM:ServiceCredencialesM;
}

export class DetFirmanteM {
  c_firmante:Number;
  c_constancia:Number;
  n_secuencia:Number;
  c_usuario:Number;
  x_nombres:String;
  c_oficina:Number;
  x_oficina:String;
}

